import VideoOpts from './video.vue';

let vueClass,
  vuePlugin = {},
  vueInstance;

vuePlugin.install = function(Vue, opt) {
  let root = opt.root,
    router = opt.router;

  router.addRoutes([
    {
      path: '/vx-video-play',
      name: 'vx-video-play',
      component: () => import('./video.vue'),
      meta: {
        vx_animate: 'none',
      },
    },
  ]);

  //   Object.defineProperty(root, 'video', {
  //     get: function() {
  //       if (!vueInstance) {
  //         let el = document.createElement('div');
  //         document.querySelector('body').appendChild(el);

  //         vueClass = Vue.extend(VideoOpts);
  //         vueInstance = new vueClass({
  //           el,
  //           router,
  //         });
  //       }
  //       return vueInstance;
  //     },
  //   });

  root.video = {
    play: function(url, config) {
      router.push(
        {
          path: '/vx-video-play',
          query: {
            url: url,
          },
        }
        // route => {
        //   route.meta._resolve = resolve;
        //   route.meta._reject = reject;
        //   route.meta.options = options;
        // },
        // err => {
        //   console.log(err);
        // }
      );
    },
  };
};

export default vuePlugin;
